<template>
  <tool-advance-filter-content
    :contentInfo="contentInfo"
    :addButtonText="addButtonText"
    :chartProperties="chartProperties"
    :chartData="chartGraphData"
    :linePlotData="linePlotData"
    :selectedComponent="superSelectedComponent"
    :isNotShowGraph="isNotShowGraph"
    :updateButtonText="updateButtonText"
    :headers="headers"
    :rows="rows"
    :singleHeading="singleHeading"
    :isShowHint="isShowHint"
    :infoText="infoText"
    :infoError="infoError"
    :emptyChartMessage="emptyChartMessage"
    @addRow="addRow"
    @editableRowButtonClick="genericMethodClick"
    @setFocusOnRowElement="setFocusOnRowElement"
    :focusElementName="focusElementName"
    :gridButtonTemplate="gridButtonTemplate"
    :singleHeadingOptions="singleHeadingOptions"
    :singleHeadingButtonText="singleHeadingButtonText"
    :gridSplitId="gridSplitId"
    @GridSelectionChange="AddNewTypeRow"
    :rowTemplateButton="rowTemplateButton"
    @rowTemplateButtonClick="genericMethodClick"
    @OuterRowButtonClick="genericMethodClick"
    :rowOuterButton="rowOuterButton"
    @onChange="OnOptionChange"
    :emptyGridData="emptyGridData"
    @removeRow="removeRow"
    @onChangeChartTab="onChangeSuperChartTab"
  ></tool-advance-filter-content>
</template>
<script>
import { ToolAdvanceFilterContent } from "../../component/tool";
import { AdvanceSuperFilter } from "../../helpers/constant";
import {
  EngagementToolCommon,
  SuperannuationAdvanceFilterContent,
} from "../../mixin";
import {
  GET_SELECTED_SUPERANNUATION_INFORMATION,
  GET_SUPERANNUATION_INFORMATION,
} from "../../helpers/vuex-constants";
import { mapGetters } from "vuex";

import _ from "lodash";
export default {
  props: {
    baselineData: {
      type: Array,
    },
    clientId: {
      type: Number,
    },
    clientName: {
      type: String,
    },
  },
  components: { ToolAdvanceFilterContent },
  mixins: [EngagementToolCommon, SuperannuationAdvanceFilterContent],
  computed: {
    ...mapGetters("superannuation", {
      selectedSuperannuationData: GET_SELECTED_SUPERANNUATION_INFORMATION,
      getSuperannuationInformation: GET_SUPERANNUATION_INFORMATION,
    }),
    gridButtonTemplate() {
      let difference = true;
      let Superannuations = this.getSuperannuationInformation.filter(
        (sr) =>
          sr.superFundGuid == this.selectedSuperannuationData.superFundGuid
      );
      let ExistingData = Superannuations[0].superAddtionalDetails
        .filter(
          (sr) =>
            sr.typeId == AdvanceSuperFilter.WithdrawalPension &&
            sr.clientID == this.clientId
        )
        .map(function (t) {
          let p = {};
          p.amount1 = t.amount1;
          p.index = t.index;
          p.frequency = t.frequency;
          p.description = t.description;
          p.startDate = t.startDate;
          p.endDate = t.endDate;
          p.startDateType = t.startDateType;
          p.endDateType = t.endDateType;
          p.superTypeId = t.superTypeId;
          p.clientID = t.clientID;
          return p;
        });

      let CurrentDataObject = [];
      for (let i = 0; i < this.rows.length; i++) {
        if (ExistingData.length > 0)
          CurrentDataObject.push({
            amount1: this.rows[i].amount1.value,
            index: this.rows[i].index.value,
            frequency: this.rows[i].frequency.value,
            description: this.rows[i].description.value,
            startDate: this.rows[i].startDate.value,
            startDateType: this.rows[i].startDateType.value,
            endDate: this.rows[i].endDate.value,
            endDateType: this.rows[i].endDateType.value,
            superTypeId: this.rows[i].superTypeId.value,
            clientID:
              this.rows[i].clientID == undefined
                ? this.clientId
                : this.rows[i].clientID.value,
          });
        else {
          if (!this.validatebyrow(this.rows[i], this.rows[i].subTypeId.value)) {
            difference = false;
            break;
          }
        }
      }
      if (ExistingData.length > 0) {
        difference = _.isEqual(ExistingData, CurrentDataObject);
      }
      this.enableResetButton(difference, "UpdateGraph");
      this.enableResetButton(difference, "reset");

      return this.gridButtonTemplatedata;
    },
    legendItems() {
      return ["", "Additional Drawdowns"];
    },
    baselineFilterObject() {
      return Object.assign({}, this.baselineData);
    },
  },

  mounted() {
    this.getinsertEmptyRows(this.rows);

    this.contentInfo = {
      chartTabContent: this.getSuperTimeSeriesChartTab(),

      heading: ` ${this.clientName} Withdrawal Pension`,
      subHeading:
        "You can enter in different return at different time periods.",
      infoAlert: {
        title: "Important note",
        variation: "informational",
        text: "You can enter in different return at different time periods.",
      },
    };
  },
  data() {
    return {
      contentInfo: {},

      selectedOption: AdvanceSuperFilter.WithdrawalPension,
      emptyGridData: {
        title: "Click to add Additional Drawdowns",
        message: "",
        imagepath: "../../assets/icons/dollar.svg",
        buttonVisible: true,
        list: [],
      },
      rowOuterButton: [],
      focusElementName: "",
      rowTemplateButton: [
        {
          icon: "plus",
          size: "medium",
          variation: "flat",
          text: "Add New",
          callBackMethod: "AddNewTypeRow",
          isdisabled: false,
          key: "AddNewTypeRow",
        },
      ],
      gridButtonTemplatedata: [
        {
          icon: "eye",
          size: "medium",
          variation: "primary",
          text: "Preview Graph",
          callBackMethod: "UpdateGraph",
          isdisabled: false,
          key: "UpdateGraph",
        },
        {
          size: "medium",
          variation: "secondary",
          isdisabled: true,
          text: "Reset",
          callBackMethod: "reset",
          key: "reset",
        },
      ],
      timeSeriesChartData: [],
      emptyChartMessage: {
        message: "Add Drawdown details to create a chart.",
        btnTxt: "",
      },

      updateButtonText: "Update Graph",
      addButtonText: "Add new",
      isShowHint: true,
      infoText: ["Hit 'Tab' to move to the next cell and add a new row"],
      singleHeadingOptions: [
        {
          key: 1,
          value: "Regular",
          fields: [
            "amount1",
            "index",
            "frequency",
            "startDate",
            "endDate",
            "description",
          ],
          overlapvalidations: true,
        },
        {
          key: 2,
          value: "Lump Sum",
          fields: ["amount1", "startDate", "description", "effectiveAsOn"],
          overlapvalidations: false,
          showDateLabel: true,
        },
      ],
      singleHeadingButtonText: "",
      gridSplitId: "subTypeId",

      infoError: false,
      singleHeading: "Additional Withdrawal",
      headers: [
        {
          type: "Dropdown",
          label: "Type",
          cols: 1,
          key: "superTypeId",
          options: this.PensionTypeOptions(),
          defaultValue: "1",
          validation: true,
        },
        {
          type: "FormatInput",
          label: "Amount",
          cols: 2,
          key: "amount1",
          isAllowOnlyNumber: true,
          appendText: "",
          currencyFormat: "$,",

          max: 999999,
          length: 6,
          validation: true,
          style: {
            width: "160px",
            overflow: "visible",
          },
        },
        {
          type: "Dropdown",
          label: "Index",
          cols: 1,
          key: "index",
          options: this.indexOptions(),
          defaultValue: "AWOTE",
          validation: true,
        },
        {
          type: "Dropdown",
          label: "Frequency",
          cols: 1,
          key: "frequency",
          options: this.frequencyOption(),
          defaultValue: "Weekly",
          validation: true,
        },

        {
          type: "MonthPickerSelect",
          displayTop: true,
          showLeft: false,
          typing: true,
          label: "Start",
          text: "Date",
          cols: 2,
          key: "startDate",
          listdata: this.startOptionsNew(),
          sort: "years",
          minYear: 2022,
          yearTerm: 50,

          style: {
            width: "160px",
            overflow: "visible",
          },
          validation: true,
        },
        {
          type: "Dropdown",
          label: "Effective as on",
          cols: 2,
          Option: "",
          key: "effectiveAsOn",
          options: [
            {
              text: "Start of the month",
              value: "1",
            },
            {
              text: "End of the month",
              value: "2",
            },
          ],
          defaultValue: 1,
          validation: true,
          style: {
            width: "160px",
            overflow: "visible",
          },
        },

        {
          type: "MonthPickerSelect",
          displayTop: true,
          typing: true,
          label: "End",
          cols: 2,
          key: "endDate",
          listdata: this.startOptionsNew(),
          sort: "years",
          minYear: 2022,
          yearTerm: 50,

          style: {
            width: "160px",
            overflow: "visible",
          },
          validation: true,
        },
        {
          type: "Input",
          label: "Description",
          placeholder: "e.g Change in Rates",
          isAllowToAddNextRow: true,
          cols: 2,
          Option: "",
          key: "description",
          length: 200,
        },

        {
          type: "Icon",
          label: "",
          iconText: "Validation",
          icon: "check",
          cols: 1,
          isShowDelete: true,
          isShowSuccess: false,
          class: "cf-Icon-Align",
          style: {
            width: "50px",
          },
          data: [
            {
              label: "",
              iconText: "Delete",
              icon: "trash",
              type: "icon",
              path: "",
              action: "delete",
            },
          ],
        },
      ],
      rows: this.fillGrid(),
    };
  },
  async created() {},
  beforeMount() {
    this.superValidations(
      this.baselineFilterObject.superAddtionalDetails,
      AdvanceSuperFilter.WithdrawalPension,
      this.clientId
    );
  },
  beforeDestroy() {
    this.fillSuperannuationModel(
      AdvanceSuperFilter.WithdrawalPension,
      this.clientId
    );
    this.superValidations(
      this.baselineFilterObject.superAddtionalDetails,
      AdvanceSuperFilter.WithdrawalPension,
      this.clientId
    );
  },
  methods: {
    async UpdateGraph() {
      await this.updateAllAdvanceSuperGraph(
        AdvanceSuperFilter.WithdrawalPension,
        this.clientId
      );
    },
    DeleteSubtype(data) {
      this.rows = this.rows.filter((x) => x.subTypeId.value != data);
    },

    fillGrid() {
      let gridRows = [];
      if (this.baselineData.superAddtionalDetails != null) {
        let data = this.baselineData.superAddtionalDetails.filter(
          (sr) =>
            sr.typeId.value == AdvanceSuperFilter.WithdrawalPension &&
            sr.clientID.value == this.clientId
        );
        if (data != null && data.length > 0) {
          gridRows = this.emptyGridRow(data);
        }
      }
      return gridRows;
    },

    setFocusOnRowElement() {
      this.focusElementName = this.headers[0].key + "0";
    },
    fillData(data, subtypeid) {
      let IsDataundfined = data == undefined;
      let startDateType = IsDataundfined
        ? 0
        : data.startDateType.value == 0
        ? 6
        : data.startDateType.value;
      let endDateType = IsDataundfined
        ? 0
        : data.endDateType.value == 0
        ? 6
        : data.endDateType.value;
      let emptyObject = {
        subTypeId: {
          value: IsDataundfined ? subtypeid : data.subTypeId.value,
          IsError: IsDataundfined ? false : data.subTypeId.IsError,
          ErrorText: IsDataundfined ? [] : data.subTypeId.ErrorText,
          disable: IsDataundfined ? false : data.subTypeId.disable,
        },
        index: {
          value: IsDataundfined ? 0 : data.index.value,
          IsError: IsDataundfined ? false : data.index.IsError,
          ErrorText: IsDataundfined ? [] : data.index.ErrorText,
          disable: IsDataundfined ? false : data.index.disable,
        },
        amount1: {
          value: IsDataundfined ? 0 : data.amount1.value,
          IsError: IsDataundfined ? false : data.amount1.IsError,
          ErrorText: IsDataundfined ? [] : data.amount1.ErrorText,
          disable: IsDataundfined ? false : data.amount1.disable,
        },
        frequency: {
          value: IsDataundfined ? 0 : data.frequency.value,
          IsError: IsDataundfined ? false : data.frequency.IsError,
          ErrorText: IsDataundfined ? [] : data.frequency.ErrorText,
          disable: IsDataundfined ? false : data.frequency.disable,
        },
        startDate: {
          value: IsDataundfined ? "" : data.startDate.value,
          IsError: IsDataundfined ? false : data.startDate.IsError,
          ErrorText: IsDataundfined ? [] : data.startDate.ErrorText,
          text: IsDataundfined
            ? ""
            : this.startOptionsNew().filter((x) => x.value == startDateType)[0]
                .text,
        },
        endDate: {
          value: IsDataundfined ? "" : data.endDate.value,
          IsError: IsDataundfined ? false : data.endDate.IsError,
          ErrorText: IsDataundfined ? [] : data.endDate.ErrorText,
          text:
            IsDataundfined || data.endDate.value == ""
              ? ""
              : this.startOptionsNew().filter((x) => x.value == endDateType)[0]
                  .text,
        },
        effectiveAsOn: {
          value: IsDataundfined ? 0 : data.effectiveAsOn.value,
          IsError: IsDataundfined ? false : data.effectiveAsOn.IsError,
          ErrorText: IsDataundfined ? [] : data.effectiveAsOn.ErrorText,
          disable: IsDataundfined ? false : data.effectiveAsOn.disable,
        },
        description: {
          value: IsDataundfined ? "" : data.description.value,
          IsError: IsDataundfined ? false : data.description.IsError,
          ErrorText: IsDataundfined ? [] : data.description.ErrorText,
          disable: IsDataundfined ? false : data.description.disable,
        },
        superTypeId: {
          value: IsDataundfined ? 0 : data.superTypeId.value,
          IsError: IsDataundfined ? false : data.superTypeId.IsError,
          ErrorText: IsDataundfined ? [] : data.superTypeId.ErrorText,
          disable: IsDataundfined ? false : data.superTypeId.disable,
        },
        startDateType: {
          value: IsDataundfined ? 0 : data.startDateType.value,
          IsError: IsDataundfined ? false : data.startDateType.IsError,
          ErrorText: IsDataundfined ? [] : data.startDateType.ErrorText,
          disable: IsDataundfined ? false : data.startDateType.disable,
        },
        endDateType: {
          value: IsDataundfined ? 0 : data.endDateType.value,
          IsError: IsDataundfined ? false : data.endDateType.IsError,
          ErrorText: IsDataundfined ? [] : data.endDateType.ErrorText,
          disable: IsDataundfined ? false : data.endDateType.disable,
        },
        clientID: {
          value: IsDataundfined ? this.clientId : data.clientID.value,
        },
        typeId: {
          value: IsDataundfined
            ? AdvanceSuperFilter.WithdrawalPension
            : data.typeId.value,
          IsError: IsDataundfined ? false : data.typeId.IsError,
          ErrorText: IsDataundfined ? [] : data.typeId.ErrorText,
          disable: IsDataundfined ? false : data.typeId.disable,
        },
        newRow: IsDataundfined ? true : false,
      };
      return emptyObject;
    },
    emptyGridRow(data) {
      if (data == undefined) {
        return this.fillData();
      } else {
        let gridData = [];
        for (let i = 0; i < data.length; i++) {
          gridData.push(this.fillData(data[i]));
        }
        return gridData;
      }
    },

    getUserInputData(rows) {
      let addtionalData = [];
      for (let i = 0; i < rows.length; i++) {
        if (!this.validatebyrow(rows[i], rows[i].subTypeId.value)) {
          addtionalData.push({
            amount1: {
              value: rows[i].amount1.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].amount1.disable,
            },
            index: {
              value: rows[i].index.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].index.disable,
            },
            frequency: {
              value: rows[i].frequency.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].frequency.disable,
            },
            startDate: {
              value:
                rows[i].startDate.value == undefined
                  ? 0
                  : rows[i].startDate.value.meta == undefined
                  ? rows[i].startDate.value
                  : rows[i].startDate.value.meta,
              IsError: false,
              ErrorText: [],
              disable: rows[i].startDate.disable,
            },
            endDate: {
              value:
                rows[i].endDate.value == undefined
                  ? 0
                  : rows[i].endDate.value.meta == undefined
                  ? rows[i].endDate.value
                  : rows[i].endDate.value.meta,
              IsError: false,
              ErrorText: [],
              disable: rows[i].endDate.disable,
            },
            description: {
              value: rows[i].description.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].description.disable,
            },
            typeId: {
              value: AdvanceSuperFilter.WithdrawalPension,
              IsError: false,
              ErrorText: [],
            },
            superTypeId: {
              value: rows[i].superTypeId.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].superTypeId.disable,
            },
            subTypeId: {
              value: rows[i].subTypeId.value,
              IsError: false,
              ErrorText: [],
            },
            startDateType: {
              value:
                rows[i].startDate.value == undefined
                  ? 0
                  : rows[i].startDate.value.value == undefined
                  ? rows[i].startDateType.value
                  : rows[i].startDate.value.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].startDateType.disable,
            },
            endDateType: {
              value:
                rows[i].endDate.value == undefined
                  ? 0
                  : rows[i].endDate.value.value == undefined
                  ? rows[i].endDateType.value
                  : rows[i].endDate.value.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].endDateType.disable,
            },
            effectiveAsOn: {
              value: rows[i].effectiveAsOn.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].effectiveAsOn.disable,
            },
            clientID: {
              value:
                rows[i].clientID.value == undefined
                  ? this.clientId
                  : rows[i].clientID.value,
              IsError: false,
              ErrorText: [],
            },
            newRow: false,
          });
        }
      }
      return addtionalData;
    },
  },
};
</script>
<style lang="scss" module></style>
